import { Box, Typography } from "@mui/material";
import { VFC } from "react";
import { BackButton } from "../common/BackButton";

const Forbidden: VFC = () => {
  return (
    <Box padding={2}>
      <Typography>このページへのアクセスは許可されていません。</Typography>
      <BackButton />
    </Box>
  );
}

export default Forbidden;